import * as React from 'react'

import CircularProgress   from '@material-ui/core/CircularProgress'
import InputAdornment     from '@material-ui/core/InputAdornment'
import { TextFieldProps } from '@material-ui/core/TextField'
import DoneIcon           from '@material-ui/icons/Done'
import ErrorIcon          from '@material-ui/icons/ErrorOutline'

import * as colors       from '../../theme'
import EnhancedTextField from './EnhancedTextField'

export interface AsyncTextFieldProps extends TextFieldProps {
  validating: boolean
  valid: boolean
  eligible: boolean
  onIdle?: (props: AsyncTextFieldProps) => void
  idleDelay?: number
}

const defaultProps = {
  idleDelay: 250
}

class AsyncTextField extends React.Component<AsyncTextFieldProps> {
  public static defaultProps = defaultProps

  private timeoutId: number

  public render () {
    const {
      eligible,
      valid,
      validating,

      /* properties consumed by this component but not in render */
      onIdle,
      idleDelay,

      ...rest
    } = this.props

    let adornmentContent

    if (validating) {
      adornmentContent =
        (
          <CircularProgress size={20} />
        )
    } else if (valid) {
      /* valid & not validating */
      adornmentContent =
        (
          <DoneIcon nativeColor={colors.success.main} />
        )
    } else if (eligible) {
      /* not valid & eligible for validity judgement & not validating */
      adornmentContent =
        (
          <ErrorIcon color={'error'} />
        )
    } else {
      adornmentContent = null
    }

    const adornment =
      (
        <InputAdornment position={'end'}>
          {adornmentContent}
        </InputAdornment>
      )

    return (
      <EnhancedTextField
        InputProps={{ endAdornment: adornment }}
        {...rest}
        onChange={this.handleChange}
      />
    )
  }

  private handleChange = (e) => {
    const { onChange, idleDelay } = this.props

    if (onChange) {
      onChange(e)
    }

    if (this.timeoutId) {
      window.clearTimeout(this.timeoutId)
    }

    this.timeoutId = window.setTimeout(
      this.handleIdle,
      idleDelay,
    )
  }

  private handleIdle = () => {
    const { onIdle } = this.props

    if (onIdle) {
      onIdle(this.props)
    }
  }
}

export default AsyncTextField



// WEBPACK FOOTER //
// ./src/components/atoms/AsyncTextField.tsx